import { gql } from "@apollo/client";

import { groupDetailsFragment } from "../fragments";

export const saveGroupV2 = gql`
    mutation saveGroupV2(
        $id: String
        $name: String
        $status: GroupStatus
        $description: String
        $organizationId: String = null
    ) {
        saveGroupV2(
            input: { id: $id, name: $name, status: $status, organizationId: $organizationId, description: $description }
        ) {
            ...GroupDetails
        }
    }
    ${groupDetailsFragment}
`;
